import { makeStyles } from '@material-ui/core/styles';

export const useViewTableStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    // padding: theme.spacing(3),
    '& .MuiTableHead-root': {
      // backgroundColor: 'none'
    },
    '& .MuiTableRow-root': {
      '&:last-child': {
        '& .MuiTableCell-root': {
          borderBottom: 'none'
        }
      }
    }
  },
  paper: {
    width: '100%',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(1),
    paddingTop: `${theme.spacing(3)}px !important`,
    '& .MuiFormControl-root': {
      minWidth: 'auto'
    },
    overflow: 'hidden'
  },
  tableContainer: {
    maxHeight: '85vh',
    borderRadius: '4px 4px 0px 0px',
    background: 'white',
    padding: theme.spacing(3),
    paddingTop: 0,
    borderTop: `${theme.spacing(3)}px solid white`
  },
  cellDate: { width: '18rem' },
  spaced: {},
  table: {
    background: 'white',
    // minWidth: 750,
    '& .MuiTableBody-root': {
      '& .MuiTableCell-root': {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
        borderBottom: `1px solid ${theme.palette.primary.main}`
      },
      '& .MuiTableRow-root': {
        '&:hover': {
          background: `${theme.palette.primary.main} !important`,
          '& .MuiTableCell-root': {
            fontWeight: 'bold',
            color: 'white'
          },
          '& .MuiIconButton-label': {
            color: 'white !important'
          },
          '& .MuiSvgIcon-root': {
            color: 'white !important'
          },
          '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: theme.palette.primary.light
          }
        },
        '&:nth-child(odd)': {
          backgroundColor: theme.palette.primary.lighter
        }
      }
    },
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      padding: theme.spacing(2),
      fontSize: '14px',
      color: theme.palette.primary.dark
    },
    '& .MuiTableCell-stickyHeader': {
      backgroundColor: theme.palette.primary.lighter
    },
    '& .MuiTableRow-root.MuiTableRow-hover:hover': {
      backgroundColor: 'transparent'
    },
    '& .MuiIconButton-label': {
      color: theme.palette.primary.main
    },
    '& .MuiRating-decimal': {
      '& .MuiSvgIcon-root': {
        color: 'inherit !important'
      }
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main
    },
    '& .MuiFormControlLabel-root': {
      margin: 0,
      '& .MuiSwitch-root': {}
    }
  },
  ellipsis: {
    maxWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& span': {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  tooltip: {
    fontSize: theme.font.size.m
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  summary: {
    marginBottom: '1rem',
    alignItems: 'center'
  },
  empty: {
    backgroundColor: 'white',
    '&.MuiTableRow-root.MuiTableRow-hover:hover': {
      backgroundColor: 'white'
    }
  },
  highlight: {
    color: theme.palette.primary.main
  },
  selected: {
    flex: 1,
    marginLeft: '1rem'
  },
  footerWrapper: {
    borderRadius: '0px 0px 4px 4px',
    background: 'white',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'end',
    '& .MuiTablePagination-toolbar': {
      alignItems: 'center !important'
    },
    '& .MuiToolbar-root': {
      padding: 0,
      color: theme.palette.primary.dark,
      '& .MuiTablePagination-caption': {
        fontSize: '13px'
      },
      '& .MuiTablePagination-input': {
        fontSize: '13px'
      },
      '& .MuiButtonBase-root': {
        '&:not(.Mui-disabled)': {
          color: theme.palette.primary.dark
        }
      }
    }
  },
  wrapper: {
    display: 'flex',
    flexGrow: 1,
    borderTop: `1px solid ${theme.palette.primary.light}`
  },
  headCell: {
    color: theme.palette.primary.dark,
    fontWeight: theme.font.weight.black,
    fontSize: '14px'
  },
  filterRow: {
    '& th': {
      '&.MuiTableCell-root': {
        paddingTop: theme.spacing(1)
      }
    },
    '& td': {
      '&.MuiTableCell-root': {
        paddingTop: theme.spacing(1)
      }
    },
    '& .MuiTableCell-root': {
      borderBottom: `1px solid ${theme.palette.primary.main}`
    },
    '& .MuiInputBase-root': {
      fontSize: '13px'
    },
    '& .MuiInput-underline': {
      color: theme.palette.primary.main,
      '&:hover': {
        '&::before': {
          borderBottom: `2px solid ${theme.palette.primary.main}`
        }
      },
      '&::before': {
        borderBottom: `1px solid ${theme.palette.primary.main}`
      }
    }
  },
  filterCell: {
    textAlign: 'center'
  },
  summaryRow: {
    backgroundColor: theme.palette.table.summary,
    height: '53px'
  },
  summaryCell: {
    fontWeight: theme.font.weight.semibold
  },
  verticalAlign: {
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  disabled: {
    opacity: 0.5
  },
  flexReverse: {
    flexDirection: 'column-reverse'
  },
  actionCell: {
    width: 0,
    paddingTop: '0 !important',
    paddingBottom: '0 !important'
  }
}));
